import { Stack } from 'expo-router';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';

export default function Layout() {
  return (
    <FullHeightWrapper>
      <Stack screenOptions={{ headerShown: false, animation: 'none' }}>
        <Stack.Screen name="index" />
        <Stack.Screen name="[overviewDate]" />
      </Stack>
    </FullHeightWrapper>
  );
}
